var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioEncoder = function SvgAudioEncoder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.71 19.54c-.12 0-.25-.03-.36-.09a.7.7 0 0 1-.35-.61v-6.49c0-.25.14-.49.35-.61.22-.13.49-.13.71 0l5.63 3.25a.702.702 0 0 1-.01 1.22l-5.63 3.25a.74.74 0 0 1-.36.09zm.29-6.7v5.48l4.75-2.74zm-4.23 1.51H3v-1h5.77zm6.32-5.18H3v-1h12.09zm0-5.18H3V3h12.09v1z"
  })));
};
export default SvgAudioEncoder;